import { ReactComponent as ConncetionSearchSvg } from "./connection-search.svg";
const ConnectionSearchIcon = (props) => {
  return <ConncetionSearchSvg {...props} />;
};
export default ConnectionSearchIcon;
